<template>
  <modal :name="modalName" :width="520">
    <div>
      <header class="modal-header center-md center-xs py15 px65 h3 sans-serif weight-700 bg-cl-secondary flex">
        <span>{{ $t('ATTENTION! New phone number!') }}</span>
        <i slot="close" class="modal-close material-icons p15 cl-bg-tertiary" @click="close" data-testid="closeModalButton">
          close
        </i>
      </header>
      <div class="modal-content verify-phone-number">
        <p>{{ $t('Your phone number has changed. This will result in your payment cards being unlinked from IPAY. Continue?') }}</p>
        <div class="flex">
          <button type="button" class="block brdr-none py10 bg-cl-korzyna-green cl-white sans-serif fs-medium profile-block-actions-btn" @click="close">
            {{ $t('Cancel') }}
          </button>
          <button type="button" class="block brdr-none py10 bg-cl-korzyna-green cl-white sans-serif fs-medium profile-block-actions-btn" @click="confirm">
            {{ $t('OK') }}
          </button >
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from 'theme/components/core/Modal'

export default {
  name: 'ConfirmPhoneChangeModal',
  components: {
    Modal
  },
  data () {
    return {
      modalName: 'confirm-phone-change'
    }
  },
  methods: {
    close () {
      this.$bus.$emit('modal-hide', this.modalName)
    },
    confirm () {
      this.$emit('closeConfirmPhoneModal');
      this.close()
    }
  }
}
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 600px) {
  .modal-header span {
    margin-top: 20px;
  }
}
.verify-phone-number {
  padding: 25px;
  padding-bottom: 5px;
}
.profile-block-actions-btn {
  width: 40%;
  margin: 10px 30px;
  border-radius: 5px;
}
</style>
